var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_343_4634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.85791,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_343_4634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.8579L5 18.0579V12.0579L1 9.85791L12 3.85791L23 9.85791V17.8579H21V10.9579L19 12.0579V18.0579L12 21.8579ZM12 13.5579L18.85 9.85791L12 6.15791L5.15 9.85791L12 13.5579ZM12 19.5829L17 16.8829V13.1079L12 15.8579L7 13.1079V16.8829L12 19.5829Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCap);
export default __webpack_public_path__ + "static/media/GradCap.b4fc1c34e2489dc4fa937c7797ad5fb0.svg";
export { ForwardRef as ReactComponent };